import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const FAVOURITES_TOPBAR_AB_TEST_ID = "rp-favourites-topbar";
export const FAVOURITES_TOPBAR_CONTROL_VARIANT = "rp_favourites_topbar_2026_10_control" as const;
export const FAVOURITES_TOPBAR_TREATMENT_VARIANT = "rp_favourites_topbar_2026_10_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose
 * `rp_favourites_topbar_2026_10_control` and `rp_favourites_topbar_2026_10_treatment` variants. The cookie keeps the assignment stable
 * when Amplitude is temporarily unavailable and remains part of the SSR cache key.
 * Override in dev: ?ab_test_experiment=rp-favourites-topbar&ab_test_variant=rp_favourites_topbar_2026_10_treatment|rp_favourites_topbar_2026_10_control
 */
export const favouritesTopbarAbTest: IABTestConfiguration = {
    id: FAVOURITES_TOPBAR_AB_TEST_ID,
    name: OngoingABTests.FAVOURITES_TOPBAR,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const FAVOURITES_TOPBAR_AB_TEST_ID = "rp-favourites-topbar";
export const FAVOURITES_TOPBAR_CONTROL_VARIANT = "rp_favourites_topbar_2026_10_control" as const;
export const FAVOURITES_TOPBAR_TREATMENT_VARIANT = "rp_favourites_topbar_2026_10_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose
 * `rp_favourites_topbar_2026_10_control` and `rp_favourites_topbar_2026_10_treatment` variants. The cookie keeps the assignment stable
 * when Amplitude is temporarily unavailable and remains part of the SSR cache key.
 * Override in dev: ?ab_test_experiment=rp-favourites-topbar&ab_test_variant=rp_favourites_topbar_2026_10_treatment|rp_favourites_topbar_2026_10_control
 */
export const favouritesTopbarAbTest: IABTestConfiguration = {
    id: FAVOURITES_TOPBAR_AB_TEST_ID,
    name: OngoingABTests.FAVOURITES_TOPBAR,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};
